import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-amber-500 text-slate-900 hover:bg-amber-400 focus:ring-amber-500 shadow-lg shadow-amber-500/20',
    secondary: 'bg-slate-800 text-slate-50 hover:bg-slate-700 focus:ring-slate-500 border border-slate-700',
    outline: 'bg-transparent border-2 border-slate-200 text-slate-200 hover:bg-slate-800 focus:ring-slate-500',
    ghost: 'bg-transparent text-slate-300 hover:text-white hover:bg-slate-800/50'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-157">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-158" />}
      {children}
    </button>;
}